import * as React from "react";

const CustomCross: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15">
            <line x1="0" y1="0" x2="24" y2="24" stroke="#808080" stroke-width="1.5" />
            <line x1="24" y1="0" x2="0" y2="24" stroke="#808080" stroke-width="1.5" />
        </svg>
    )
};

export default React.memo(CustomCross);
